'use client';

import { type ReactNode } from 'react';

import { Typography } from '@/components/atoms';

export interface CarouselShellProps {
  title?: string;
  titleClassName?: string;
  headerAction?: ReactNode;
  footer?: ReactNode;
  children: ReactNode;
}

export const CarouselShell = ({
  title,
  titleClassName,
  headerAction,
  footer,
  children,
}: CarouselShellProps) => (
  <>
    {(title || headerAction) &&
      (headerAction ? (
        <div className="w-full flex justify-between items-center">
          {title && (
            <Typography.Heading variant="h5" className={titleClassName}>
              {title}
            </Typography.Heading>
          )}
          {headerAction}
        </div>
      ) : (
        <Typography.Heading variant="h5" className={titleClassName}>
          {title}
        </Typography.Heading>
      ))}
    {children}
    {footer}
  </>
);
